var CameraFunctions = {
    isCordovaCameraAvailable: function () {
        return typeof window !== 'undefined' &&
            window.cordova &&
            navigator.camera &&
            typeof navigator.camera.getPicture === 'function';
    },

    capturePhoto: function (successCallback, errorCallback, options) {
        var defaultOptions = {
            quality: 50,
            destinationType: (typeof Camera !== 'undefined' && Camera.DestinationType) ? Camera.DestinationType.FILE_URI : undefined,
            encodingType: (typeof Camera !== 'undefined' && Camera.EncodingType) ? Camera.EncodingType.JPEG : undefined,
            targetWidth: 800,
            targetHeight: 800,
            allowEdit: false,
            correctOrientation: true,
            saveToPhotoAlbum: false,
            cameraDirection: (typeof Camera !== 'undefined' && Camera.Direction) ? Camera.Direction.FRONT : undefined
        };
        var mergedOptions = Object.assign({}, defaultOptions, options);

        if (CameraFunctions.isCordovaCameraAvailable()) {
            navigator.camera.getPicture(
                function (imageURI) {
                    if (typeof successCallback === 'function') {
                        successCallback(imageURI);
                    }
                },
                function (message) {
                    if (typeof errorCallback === 'function') {
                        errorCallback('Failed because: ' + message);
                    }
                },
                mergedOptions
            );
            return;
        }

        var isWebView = /(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/i.test(navigator.userAgent) || 
                        /(Android).*Version\/[0-9]\.[0-9]/i.test(navigator.userAgent) || 
                        /wv/.test(navigator.userAgent) || 
                        window.flutter_inappwebview || 
                        navigator.userAgent.includes("Flutter");

        if (isWebView) {
            CameraFunctions.openNativeFileCapture(successCallback, errorCallback);
        } else {
            CameraFunctions.openBrowserCamera(successCallback, errorCallback, mergedOptions);
        }
    },

    openBrowserCamera: function (successCallback, errorCallback, options) {
        if (typeof window === 'undefined' || typeof document === 'undefined' || !navigator.mediaDevices || !navigator.mediaDevices.getUserMedia) {
            if (typeof errorCallback === 'function') {
                errorCallback('Camera API is not supported in this browser.');
            }
            return;
        }

        var overlay = document.createElement('div');
        overlay.style.position = 'fixed';
        overlay.style.top = '0';
        overlay.style.left = '0';
        overlay.style.width = '100vw';
        overlay.style.height = '100vh';
        overlay.style.backgroundColor = '#000';
        overlay.style.zIndex = '999999';
        overlay.style.display = 'flex';
        overlay.style.flexDirection = 'column';

        var videoContainer = document.createElement('div');
        videoContainer.style.flex = '1';
        videoContainer.style.display = 'flex';
        videoContainer.style.alignItems = 'center';
        videoContainer.style.justifyContent = 'center';
        videoContainer.style.overflow = 'hidden';
        videoContainer.style.backgroundColor = '#000';

        var video = document.createElement('video');
        video.style.width = '100%';
        video.style.height = '100%';
        video.style.objectFit = 'cover';
        video.autoplay = true;
        video.playsInline = true;

        videoContainer.appendChild(video);

        var controls = document.createElement('div');
        controls.style.height = '100px';
        controls.style.display = 'flex';
        controls.style.alignItems = 'center';
        controls.style.justifyContent = 'space-around';
        controls.style.backgroundColor = '#111';
        controls.style.paddingBottom = 'env(safe-area-inset-bottom)';

        var closeBtn = document.createElement('button');
        closeBtn.innerText = 'Cancel';
        closeBtn.style.padding = '10px 20px';
        closeBtn.style.fontSize = '16px';
        closeBtn.style.color = '#fff';
        closeBtn.style.backgroundColor = 'transparent';
        closeBtn.style.border = 'none';
        closeBtn.style.cursor = 'pointer';

        var captureBtn = document.createElement('button');
        captureBtn.innerText = 'Capture';
        captureBtn.style.padding = '15px 30px';
        captureBtn.style.fontSize = '18px';
        captureBtn.style.color = '#000';
        captureBtn.style.backgroundColor = '#fff';
        captureBtn.style.border = 'none';
        captureBtn.style.borderRadius = '25px';
        captureBtn.style.fontWeight = 'bold';
        captureBtn.style.cursor = 'pointer';

        var switchBtn = document.createElement('button');
        switchBtn.innerHTML = '<i class="fas fa-sync-alt"></i>';
        switchBtn.style.padding = '10px 20px';
        switchBtn.style.fontSize = '20px';
        switchBtn.style.color = '#fff';
        switchBtn.style.backgroundColor = 'transparent';
        switchBtn.style.border = 'none';
        switchBtn.style.cursor = 'pointer';
        switchBtn.style.display = 'none'; // hidden until multiple cameras are confirmed

        // Check for multiple cameras
        if (navigator.mediaDevices.enumerateDevices) {
            navigator.mediaDevices.enumerateDevices().then(function(devices) {
                var videoInputs = devices.filter(function(device) { return device.kind === 'videoinput'; });
                if (videoInputs.length > 1) {
                    switchBtn.style.display = 'block';
                }
            }).catch(function(err) {
                console.log("Could not enumerate devices:", err);
            });
        }

        controls.appendChild(closeBtn);
        controls.appendChild(captureBtn);
        controls.appendChild(switchBtn);

        overlay.appendChild(videoContainer);
        overlay.appendChild(controls);
        document.body.appendChild(overlay);

        var streamRef = null;
        var currentFacingMode = 'user'; // Default to front camera

        var startCamera = function(facingMode) {
            if (streamRef) {
                streamRef.getTracks().forEach(function(track) {
                    track.stop();
                });
            }
            
            // Try specific facing mode, with a fallback if that fails
            var constraints = { video: { facingMode: facingMode } };
            
            navigator.mediaDevices.getUserMedia(constraints)
                .then(function(stream) {
                    streamRef = stream;
                    video.srcObject = stream;
                })
                .catch(function(err) {
                    console.log("Failed with facingMode " + facingMode + ", falling back to default.", err);
                    // Fallback to any available camera if the specific facingMode fails
                    navigator.mediaDevices.getUserMedia({ video: true })
                        .then(function(stream) {
                            streamRef = stream;
                            video.srcObject = stream;
                        })
                        .catch(function(fallbackErr) {
                            document.body.removeChild(overlay);
                            if (typeof errorCallback === 'function') {
                                errorCallback('Could not access camera: ' + fallbackErr.message);
                            }
                        });
                });
        };

        // Initialize camera
        startCamera(currentFacingMode);

        switchBtn.onclick = function() {
            currentFacingMode = currentFacingMode === 'user' ? 'environment' : 'user';
            startCamera(currentFacingMode);
        };

        var cleanup = function() {
            if (streamRef) {
                if (typeof streamRef.stop === 'function') {
                    streamRef.stop();
                }
                streamRef.getTracks().forEach(function(track) {
                    track.stop();
                });
                video.srcObject = null;
            }
            if (overlay.parentNode) {
                overlay.parentNode.removeChild(overlay);
            }
        };

        closeBtn.onclick = function() {
            cleanup();
            if (typeof errorCallback === 'function') {
                errorCallback('Camera closed by user.');
            }
        };

        captureBtn.onclick = function() {
            var canvas = document.createElement('canvas');
            canvas.width = video.videoWidth || video.clientWidth;
            canvas.height = video.videoHeight || video.clientHeight;
            var ctx = canvas.getContext('2d');
            ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
            
            var dataUrl = canvas.toDataURL('image/jpeg', 1.0);
            cleanup();
            CameraFunctions.processImageDataUrl(dataUrl, options, successCallback, errorCallback);
        };
    },

    processImageDataUrl: function (dataUrl, options, successCallback, errorCallback) {
        if ((!options.targetWidth && !options.targetHeight) || typeof document === 'undefined') {
            if (typeof successCallback === 'function') {
                successCallback(dataUrl);
            }
            return;
        }

        var img = new Image();
        img.onload = function () {
            var targetWidth = options.targetWidth || img.width;
            var targetHeight = options.targetHeight || img.height;
            var ratio = Math.min(targetWidth / img.width, targetHeight / img.height, 1);
            var canvas = document.createElement('canvas');
            canvas.width = Math.round(img.width * ratio);
            canvas.height = Math.round(img.height * ratio);
            var ctx = canvas.getContext('2d');
            ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
            var quality = Math.min(Math.max((options.quality || 80) / 100, 0.1), 1);
            var resizedDataUrl = canvas.toDataURL('image/jpeg', quality);
            if (typeof successCallback === 'function') {
                successCallback(resizedDataUrl);
            }
        };
        img.onerror = function () {
            if (typeof errorCallback === 'function') {
                errorCallback('Failed to process selected photo.');
            }
        };
        img.src = dataUrl;
    },

    openNativeFileCapture: function(successCallback, errorCallback) {
        var input = document.createElement('input');
        input.type = 'file';
        input.accept = 'image/*';
        input.capture = 'environment';
        input.style.display = 'none';

        input.onchange = function(e) {
            var file = e.target.files[0];
            if (!file) {
                if (typeof errorCallback === 'function') errorCallback('No image selected');
                return;
            }
            var reader = new FileReader();
            reader.onload = function(event) {
                var base64Data = event.target.result;
                if (typeof successCallback === 'function') {
                    successCallback(base64Data);
                }
            };
            reader.onerror = function(err) {
                if (typeof errorCallback === 'function') errorCallback('Error reading file');
            }
            reader.readAsDataURL(file);
        };

        document.body.appendChild(input);
        input.click();
        
        setTimeout(function() {
            document.body.removeChild(input);
        }, 1000);
    }
};
export default CameraFunctions;
